import React, { Component } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import ModalMessage from '../../../shared/components/Modal';
import FormHelperText from '@material-ui/core/FormHelperText';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from 'moment';

import MomentUtils from '@date-io/moment';
import "moment/locale/es";

const typeCares = ['Consulta Médica', 'Procedimiento', 'Tratamiento', 'Holter Cardíaco', 'Holter de Presión'];

class FormGenerateAgendaDaily extends Component {
  constructor(props) {
    super(props);
    this.state = {
      specialists: [],
      specialty: this.props.professional.id_especialidad,
      professionals: [],
      professional: this.props.professional,
      id_profesional: this.props.professional.id_profesional,
      services: [],
      service: '',
      workspaces: [],
      workspace: '',
      typecare: '',
      dateStart: this.props.selected_day,
      dateEnd: this.props.selected_day,
      durations: [10, 20, 25, 30, 35, 40, 45, 50, 55, 60],
      duration: '',
      errors: {},
      openAlert: false,
      modalAlert: { title: '', color: '', message: '' }
    };
  };

  componentDidMount() {
    console.log(this.props.event);
    this.getData();
  }

  getData = () => {
    Promise.all([this.fetchDataSpecialist(), this.fetchDataProfessionals(), this.fetchDataServices(), this.fetchDataWorkspace()]).then((result) => {
      console.log(JSON.stringify(result));
      this.setState({ specialists: result[0], professionals: result[1], services: result[2], workspaces: result[3] });
    })
      .catch(error => console.log(`Error in promises ${error}`));

  }

  fetchDataSpecialist = () => {
    console.log(process.env.REACT_APP_PUBLIC_URL + 'especialidad/listar');
    console.log('Bearer ' + sessionStorage.getItem('token'));

    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'especialidad/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          console.log(response);
          return response.json();
        })
        .then(specialists => {
          console.log("Sucess:" + specialists);
          resolve(specialists);
        })
        .catch((error) => {
          reject(error)
        });
    });
  };

  fetchDataProfessionals = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'profesional/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          console.log(response);
          return response.json();
        })
        .then(professionals => {
          console.log("Sucess:" + professionals);
          resolve(professionals);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  fetchDataServices = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'servicio/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(services => {
          console.log("Sucess:" + services);
          resolve(services);
        })
        .catch((error) => {
          reject(error);
        });
    })
  };

  fetchDataWorkspace = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'espacio/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          console.log(response);
          return response.json();
        })
        .then(workspace => {
          console.log("Sucess:" + workspace);
          resolve(workspace);
        })
        .catch((error) => {
          reject(error);
        });
    })
  };

  validateData = () => {

    var errors = this.state.errors;
    var error = false;
    if (this.state.professional === '') {
      errors.professional = "seleccione profesional";
      error = true;
    } else {
      errors.professional = '';
    }

    if (this.state.duration === '') {
      errors.duration = "seleccione una duración";
      error = true;
    } else {
      errors.duration = "";
    }

    if (this.state.service === '') {
      errors.service = "seleccione un servicio";
      error = true;
    } else {
      errors.service = "";
    }

    if (this.state.workspace === '') {
      errors.workspace = "seleccione un espacio";
      error = true;
    } else {
      errors.workspace = "";
    }

    if (moment(this.state.dateStart).diff(new Date(), 'hours') <= 0) {
      error = true;
      console.log(error);
      errors.dateStart = "Seleccione un fecha de inicio valida";
    } else {
      errors.dateStart = "";
    }

    if (moment(this.state.dateEnd).diff(new Date()) <= 0) {
      error = true;
      console.log(error);
      errors.dateEnd = "seleccione un fecha de fin valida";
    } else {
      errors.dateEnd = "";
    }
    console.log(errors);
    this.setState({ errors: errors }, () => {
      if (!error) {
        console.log(this.props);
        if (this.props.event !== undefined) {
          this.fetchSendData();
        } else {
          alert("jornada indefinida")
        }
      };
    });
    //history.push('/pages/agenda-asign-day');
  }


  fetchSendData = () => {
    console.log(this.props.event)
    console.log(this.props.professional)
    var data = {
      id_agenda: this.state.professional.id_agenda_activa,
      jornada: this.props.event.jornada,
      inicio: moment(this.state.dateStart).format("hh:mm A"),
      fin: moment(this.state.dateEnd).format("hh:mm A"),
      intervalo: this.state.duration,
    };

    console.log(data);

    fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda/modificarjornada', {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        "authorization": "Bearer " + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.text();
      })
      .then(data => {
        console.log("Sucess:" + data);
        alert(data);
        this.setState({ openAlert: true, modalAlert: { title: "Exitoso", message: data, color: "success" } });

        //history.push('/pages/agenda-asign-day');
      })
      .catch((error) => {
        console.log(error);
      });
  };


  handlerSpeciality = (event) => {
    this.setState({ specialty: event.target.value });
  }

  handlerProfessional = (event) => {
    this.setState({ professional: event.target.value });
  }

  handlerService = (event) => {
    this.setState({ service: event.target.value });
  }

  handlerSpace = (event) => {
    this.setState({ workspace: event.target.value });
  }

  handlerDuration = (event) => {
    this.setState({ duration: event.target.value });
  }

  handleDateStartChange = (date) => {
    console.log(date);
    this.setState({ dateStart: date.toDate() });
  }

  handleDateEndChange = (date) => {
    this.setState({ dateEnd: date.toDate() });
  }

  handlerTypeOfMedicalCare = (event) => {
    this.setState({ typecare: event.target.value });
  }

  render() {

    return (<Col md={12}>
      <Card>
        <CardBody>
          <Row>
            <Col md={3}>
              <FormControl className='formControlAgendaLeft'>
                <InputLabel id="demo-simple-select-label">especialidad</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  defaultValue={null}
                  value={this.state.specialty}
                  onChange={(event) => {
                    this.handlerSpeciality(event);
                  }}
                >
                  <MenuItem key={0} value={''}>Ninguno</MenuItem>
                  {this.state.specialists.length > 0 ? this.state.specialists.map((specialist, index) => {
                    return <MenuItem key={specialist.id_especialidad} value={specialist.id_especialidad}>{specialist.especialidad}</MenuItem>
                  }) : null}

                  {/*<MenuItem value={30}>especialidad 2</MenuItem>*/}
                </Select>
              </FormControl>
            </Col>
            <Col md={3}>
              <FormControl className='formControlAgendaRight'>
                <InputLabel id="demo-simple-select-label">profesional</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={this.state.id_profesional}
                  onChange={(event) => {
                    this.handlerProfessional(event);
                  }}
                  disabled={true}
                  error={this.state.errors.hasOwnProperty("professional") ? this.state.errors.professional !== "" : false}
                >
                  {this.state.professionals.map((professional, index) => {
                    return <MenuItem key={professional.id_profesional} value={professional.id_profesional}>{`${professional.nombres} ${professional.apellido1} ${professional.apellido2}`}</MenuItem>
                  })}
                </Select>
                <FormHelperText>{this.state.errors.professional}</FormHelperText>
              </FormControl>
            </Col>
            <Col md={3}>
              <FormControl className='formControlAgendaLeft'>
                <InputLabel id="demo-simple-select-label">servicios</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={this.state.service}
                  onChange={(event) => {
                    this.handlerService(event);
                  }}
                  error={this.state.errors.hasOwnProperty("service") ? this.state.errors.service !== "" : false}
                >
                  {this.state.services.length > 0 ? this.state.services.map((service, index) => {
                    return <MenuItem key={service.id_servicio} value={service.id_servicio}>{service.servicio}</MenuItem>
                  }) : null}
                </Select>
                <FormHelperText>{this.state.errors.service}</FormHelperText>
              </FormControl>
            </Col>
            <Col md={3}>
              <FormControl className='formControlAgendaRight'>
                <InputLabel id="demo-simple-select-label">espacios</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={this.state.workspace}
                  onChange={(event) => {
                    this.handlerSpace(event);
                  }}
                  error={this.state.errors.hasOwnProperty("workspace") ? this.state.errors.workspace !== "" : false}
                >
                  {this.state.workspaces.length > 0 ? this.state.workspaces.map((workspace, index) => {
                    return <MenuItem key={workspace.id_espacio} value={workspace.espacio}>{workspace.espacio}</MenuItem>
                  }) : null}
                </Select>
                <FormHelperText>{this.state.errors.workspace}</FormHelperText>
              </FormControl>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <FormControl className='formControlAgendaLeft'>
                <InputLabel id="demo-simple-select-label">Duración cita</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={this.state.duration}
                  onChange={(event) => {
                    this.handlerDuration(event);
                  }}
                  defaultValue={''}
                  error={this.state.errors.hasOwnProperty("duration") ? this.state.errors.duration !== "" : false}
                >
                  <MenuItem key={0} value={''}>Ninguno</MenuItem>
                  {this.state.durations.map((duration, index) => {
                    return <MenuItem key={index} value={duration}>{duration}</MenuItem>
                  })}
                </Select>
                <FormHelperText>{this.state.errors.duration}</FormHelperText>
              </FormControl>
            </Col>
            <Col md={3}>
              <FormControl className='formControlAgendaRight'>
                <InputLabel id="demo-simple-select-label">Atención medica</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={this.state.typecare}
                  onChange={(event) => {
                    this.handlerTypeOfMedicalCare(event);
                  }}
                  defaultValue={''}
                >
                  <MenuItem key={-1} value={''}>Ninguna</MenuItem>
                  {typeCares.map((typeCare, index) => {
                    return <MenuItem key={index} value={typeCare}>{typeCare}</MenuItem>
                  })}
                </Select>
              </FormControl>
            </Col>
            <Col md={3}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardTimePicker
                  mask="__:__ _M"
                  value={this.state.dateStart}
                  onChange={this.handleDateStartChange}
                  label="Fecha y hora de inicio"
                  onError={console.log}
                  minDate={new Date("2018-01-01T00:00")}
                  format="hh:mm a"
                />
              </MuiPickersUtilsProvider>
            </Col>
            <Col md={3}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardTimePicker
                  mask="__:__ _M"
                  value={this.state.dateEnd}
                  onChange={this.handleDateEndChange}
                  label="Fecha y hora final"
                  onError={console.log}
                  minDate={new Date("2018-01-01T00:00")}
                  format="hh:mm a"
                />
              </MuiPickersUtilsProvider>
            </Col>
          </Row>
          <Row>
            <div style={{ marginTop: 20 }}>
              <Button variant="contained" color="primary"
                onClick={() => {
                  this.validateData();
                }}>
                Editar Día
              </Button>
            </div>

          </Row>

        </CardBody>
      </Card>
      {this.state.openAlert ?
        <ModalMessage
          style={{ zIndex: 3000 }}
          color={this.state.modalAlert.color}
          title={this.state.modalAlert.title}
          message={this.state.modalAlert.message}
          modal={this.state.openAlert}
          toggle={() => {
            this.setState({ openAlert: !this.state.openAlert }, () => {
              console.log(this.props.selected_day);
              this.props.reload(this.props.selected_day);
              console.log("!!!! reload")
            }
            )
          }}
        /> : null}
    </Col>)
  }
}

export default FormGenerateAgendaDaily;